<script>
import { CellGroup, Cell, Popup, Picker, List, Empty } from 'vant'
import ImageViewer from '@/fcl/components/user/ImageViewer'
import TextSwitcher from '@/fcl/components/user/TextSwitcher'
import BottomToolbar from '@/fcl/components/user/BottomToolbar'
import { QNImageUtil } from '@/fcl/utils'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-staff-detail',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-cell-group': CellGroup,
        'van-cell': Cell,
        'van-popup': Popup,
        'van-picker': Picker,
        'van-list': List,
        'van-empty': Empty,
        'image-viewer': ImageViewer,
        'text-switcher': TextSwitcher,
        'bottom-toolbar': BottomToolbar,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            staff: {
                id: null,
                organizationId: null,
                name: null,
                roleLabel: null,
                remark: null,
                isLogon: null,
                isSuperAdmin: null,
            },
            locale: {}
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        operatorIconButtons() {
            console.log('operatorIconButtons', this.staff.isLogon, this.staff.role)
            const iconButtons = []
            if (!this.staff.isLogon) {
                iconButtons.push({ type: 'invite-staff', iconType: 'vant', icon: 'wechat', label: this.locale['invite'] })
            }
            iconButtons.push({ type: 'edit-staff', iconType: 'vant', icon: 'edit', label: this.locale['edit'] })
            return iconButtons
        },
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onBottomToolbarIconClick(type) {
            if (type == 'invite-staff') {
                this.onInviteBtnClick()
            }
            else if (type == 'edit-staff') {
                this.onEditBtnClick()
            }
        },
        onInviteBtnClick() {
            console.log('onInviteBtnClick')
            this.$emit('custom-event', {
                type: 'invite-staff',
                data: {
                    id: this.staff.id,
                    organizationId: this.staff.organizationId,
                    roleLabel: this.staff.roleLabel,
                    name: this.staff.name,
                }
            })
        },
        onEditBtnClick() {
            console.log('onEditBtnClick')
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'UserOrgEditStaff',
                    params: { id: this.staff.id }
                }
            })
        },
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h) {
            // console.log('adjustImageSize', img, w, h)
            if (img) {
                return QNImageUtil.imageView(img, w, h)
            }
			else {
                return null
            }
		},
    },
}
</script>

<template>
    <div class="staff-detail">
        <van-cell-group>
            <van-cell :title="locale['staff-name-label']" :value="staff.name"/>
            <text-switcher 
                :label="locale['staff-super-admin-label']"
                :checked="staff.isSuperAdmin"
                :readonly="true"
            />
            <van-cell 
                v-if="!staff.isSuperAdmin" 
                :title="locale['staff-role-label']" 
                :value="staff.roleLabel"
            />
            <van-cell :title="locale['staff-remark']" :value="staff.remark"/>
        </van-cell-group>
        <bottom-toolbar
            type="icons"
            :mainIcons="operatorIconButtons"
            @click-main-icon="onBottomToolbarIconClick"
        />
    </div>
</template>